import React from 'react'

const Error404 = () => {
  return (
    <div className='text-9xl font-extrabold text-center my-52'>Error404</div>
  )
}

export default Error404;